import type { ContentsType } from '@/types';
import { CardTitle } from './CardTitle';
export const games: ContentsType[] = [{
  id: 'tops',
  title: <CardTitle firstText="Top-Rated" secondText="Games" isFirstGradient colorFrom="#FF5E9F" colorTo="#FF2E82" iconUrl="/assets/title-icons/2.png" mt={6} />,
  items: [{
    id: 1,
    imgCard: '/assets/tops/1.png'
  }, {
    id: 2,
    imgCard: '/assets/tops/2.png'
  }, {
    id: 3,
    imgCard: '/assets/tops/3.png'
  }, {
    id: 4,
    imgCard: '/assets/tops/4.png'
  }, {
    id: 5,
    imgCard: '/assets/tops/5.png'
  }, {
    id: 6,
    imgCard: '/assets/tops/6.png'
  }, {
    id: 7,
    imgCard: '/assets/tops/7.png'
  }, {
    id: 8,
    imgCard: '/assets/tops/3.png'
  }, {
    id: 9,
    imgCard: '/assets/tops/4.png'
  }, {
    id: 10,
    imgCard: '/assets/tops/5.png'
  }, {
    id: 11,
    imgCard: '/assets/tops/1.png'
  }, {
    id: 12,
    imgCard: '/assets/tops/2.png'
  }, {
    id: 13,
    imgCard: '/assets/tops/3.png'
  }, {
    id: 14,
    imgCard: '/assets/tops/4.png'
  }, {
    id: 15,
    imgCard: '/assets/tops/5.png'
  }, {
    id: 16,
    imgCard: '/assets/tops/6.png'
  }, {
    id: 17,
    imgCard: '/assets/tops/7.png'
  }, {
    id: 18,
    imgCard: '/assets/tops/3.png'
  }, {
    id: 19,
    imgCard: '/assets/tops/4.png'
  }, {
    id: 20,
    imgCard: '/assets/tops/5.png'
  }, {
    id: 21,
    imgCard: '/assets/tops/7.png'
  }]
}, {
  id: 'primes',
  title: <CardTitle firstText="Primeroll" secondText="Originals" isFirstGradient colorFrom="#DBFE02" colorTo="#DBFE02" iconUrl="/assets/title-icons/3.png" mt={6} />,
  items: [{
    id: 1,
    imgCard: '/assets/primes/1.png'
  }, {
    id: 2,
    imgCard: '/assets/primes/2.png'
  }, {
    id: 3,
    imgCard: '/assets/primes/3.png'
  }, {
    id: 4,
    imgCard: '/assets/primes/4.png'
  }, {
    id: 5,
    imgCard: '/assets/primes/5.png'
  }, {
    id: 6,
    imgCard: '/assets/primes/6.png'
  }, {
    id: 7,
    imgCard: '/assets/primes/7.png'
  }, {
    id: 8,
    imgCard: '/assets/primes/3.png'
  }, {
    id: 9,
    imgCard: '/assets/primes/4.png'
  }, {
    id: 10,
    imgCard: '/assets/primes/5.png'
  }]
}, {
  id: 'slots',
  title: <CardTitle firstText="Slots" isFirstGradient colorFrom="#3FBCFF" colorTo="#3F7CFF" iconUrl="/assets/title-icons/4.png" mt={6} />,
  items: [{
    id: 1,
    imgCard: '/assets/slots/1.png'
  }, {
    id: 2,
    imgCard: '/assets/slots/2.png'
  }, {
    id: 3,
    imgCard: '/assets/slots/3.png'
  }, {
    id: 4,
    imgCard: '/assets/slots/4.png'
  }, {
    id: 5,
    imgCard: '/assets/slots/5.png'
  }, {
    id: 6,
    imgCard: '/assets/slots/6.png'
  }, {
    id: 7,
    imgCard: '/assets/slots/7.png'
  }, {
    id: 8,
    imgCard: '/assets/slots/3.png'
  }, {
    id: 9,
    imgCard: '/assets/slots/4.png'
  }, {
    id: 10,
    imgCard: '/assets/slots/5.png'
  }]
}, {
  id: 'lives',
  title: <CardTitle firstText="Live games" isFirstGradient colorFrom="#F5FF6B" colorTo="#FF2A7F" iconUrl="/assets/title-icons/5.png" mt={6} />,
  items: [{
    id: 1,
    imgCard: '/assets/lives/1.png'
  }, {
    id: 2,
    imgCard: '/assets/lives/2.png'
  }, {
    id: 3,
    imgCard: '/assets/lives/3.png'
  }, {
    id: 4,
    imgCard: '/assets/lives/4.png'
  }, {
    id: 5,
    imgCard: '/assets/lives/5.png'
  }, {
    id: 6,
    imgCard: '/assets/lives/6.png'
  }, {
    id: 7,
    imgCard: '/assets/lives/7.png'
  }, {
    id: 8,
    imgCard: '/assets/lives/3.png'
  }, {
    id: 9,
    imgCard: '/assets/lives/4.png'
  }, {
    id: 10,
    imgCard: '/assets/lives/5.png'
  }]
}, {
  id: 'new-releases',
  title: <CardTitle firstText="New releases" isFirstGradient colorFrom="#FF9F69" colorTo="#FF4351" iconUrl="/assets/title-icons/8.png" mt={6} />,
  items: [{
    id: 1,
    imgCard: '/assets/new-release/1.png'
  }, {
    id: 2,
    imgCard: '/assets/new-release/2.png'
  }, {
    id: 3,
    imgCard: '/assets/new-release/3.png'
  }, {
    id: 4,
    imgCard: '/assets/new-release/4.png'
  }, {
    id: 5,
    imgCard: '/assets/new-release/5.png'
  }, {
    id: 6,
    imgCard: '/assets/new-release/6.png'
  }, {
    id: 7,
    imgCard: '/assets/new-release/7.png'
  }, {
    id: 8,
    imgCard: '/assets/new-release/3.png'
  }, {
    id: 9,
    imgCard: '/assets/new-release/4.png'
  }, {
    id: 10,
    imgCard: '/assets/new-release/5.png'
  }]
}, {
  id: 'black-jack',
  title: <CardTitle firstText="Black jack" isFirstGradient colorFrom="#3FBCFF" colorTo="#3F7CFF" iconUrl="/assets/title-icons/9.png" mt={6} />,
  items: [{
    id: 1,
    imgCard: '/assets/lives/1.png'
  }, {
    id: 2,
    imgCard: '/assets/lives/2.png'
  }, {
    id: 3,
    imgCard: '/assets/lives/3.png'
  }, {
    id: 4,
    imgCard: '/assets/lives/4.png'
  }, {
    id: 5,
    imgCard: '/assets/lives/5.png'
  }, {
    id: 6,
    imgCard: '/assets/lives/6.png'
  }, {
    id: 7,
    imgCard: '/assets/lives/7.png'
  }, {
    id: 8,
    imgCard: '/assets/lives/3.png'
  }, {
    id: 9,
    imgCard: '/assets/lives/4.png'
  }, {
    id: 10,
    imgCard: '/assets/lives/5.png'
  }]
}, {
  id: 'battles',
  title: <CardTitle firstText="Battles" isFirstGradient colorFrom="#DBFE02" colorTo="#44FF66" iconUrl="/assets/title-icons/11.png" mt={6} />,
  items: [{
    id: 1,
    imgCard: '/assets/slots/1.png'
  }, {
    id: 2,
    imgCard: '/assets/slots/2.png'
  }, {
    id: 3,
    imgCard: '/assets/slots/3.png'
  }, {
    id: 4,
    imgCard: '/assets/slots/4.png'
  }, {
    id: 5,
    imgCard: '/assets/slots/5.png'
  }, {
    id: 6,
    imgCard: '/assets/slots/6.png'
  }, {
    id: 7,
    imgCard: '/assets/slots/7.png'
  }, {
    id: 8,
    imgCard: '/assets/slots/3.png'
  }, {
    id: 9,
    imgCard: '/assets/slots/4.png'
  }, {
    id: 10,
    imgCard: '/assets/slots/5.png'
  }]
}, {
  id: 'game-show',
  title: <CardTitle firstText="Game show" isFirstGradient colorFrom="#F5FF6B" colorTo="#FF2A7F" iconUrl="/assets/title-icons/5.png" mt={6} />,
  items: [{
    id: 1,
    imgCard: '/assets/lives/1.png'
  }, {
    id: 2,
    imgCard: '/assets/lives/2.png'
  }, {
    id: 3,
    imgCard: '/assets/lives/3.png'
  }, {
    id: 4,
    imgCard: '/assets/lives/4.png'
  }, {
    id: 5,
    imgCard: '/assets/lives/5.png'
  }, {
    id: 6,
    imgCard: '/assets/lives/6.png'
  }, {
    id: 7,
    imgCard: '/assets/lives/7.png'
  }, {
    id: 8,
    imgCard: '/assets/lives/3.png'
  }, {
    id: 9,
    imgCard: '/assets/lives/4.png'
  }, {
    id: 10,
    imgCard: '/assets/lives/5.png'
  }]
}];